import { MoneySend, PayAnyone, User } from "../../../public/assets";

export const sendingMethodsData = [
  {
    title: "Send money to Fipay account",
    subTitle: "Quickly access the app without entering your login credentials",
    icon: "/assets/icons/user.svg",
    route: "/dashboard/accounts/payment-details",
  },
  {
    title: "Send money to bank accounts",
    subTitle: "Quickly access the app without entering your login credentials",
    icon: "/assets/icons/bankIcon2.svg",
    route: "/dashboard/accounts/recipient-details",
  },
  {
    title: "Wire transfer",
    subTitle: "Quickly access the app without entering your login credentials",
    icon: "/assets/icons/moneySend.svg",
    route: "/dashboard/accounts/recipient-details-wire-transfer",
  },
  {
    title: "Pay anyone",
    subTitle: "Quickly access the app without entering your login credentials",
    icon: "/assets/icons/payAnyone.svg",
    route: "/dashboard/accounts/recipient-details-pay-anyone",
  },
];
